<template>
  <div class="worker-detail-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="工人详情" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="header">
      <img class="worker-avatar" :src="imgUrl + workerDetail.avatar">
      <div class="worker-name">{{workerDetail.name}}</div>
      <div class="platform-auth"><img src="../../assets/icon-shop-auth.png"/> <div>平台认证</div></div>
    </div>
    <div class="footer">
      <div class="cell"><div class="label">工种：</div>{{workerDetail.workTypeList}}</div>
      <div class="cell"><div class="label">工龄：</div>{{workerDetail.workAge}}</div>
      <div class="cell"><div class="label">电话：</div>{{workerDetail.phone}}</div>
      <div class="cell"><div class="label">简介：</div><div class="intro">{{workerDetail.intro}}</div></div>
    </div>
  </div>
</template>
<script>
  import {imgUrl,shareIcon} from '../../config'
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import supervisorWorkerService from '../../service/onestop/OnestopSupervisorWorkerService'

  export default {
    name: 'WorkerDetail',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        id:'',
        workerDetail:{},
        imgUrl: imgUrl,
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.id = this.$route.query.id;
      this.getSupervisorWorkerDetail();
    },
    methods: {
      async getSupervisorWorkerDetail(){
        let { code, data} = await supervisorWorkerService.detail(this.id);
        if(code == 0){
          this.workerDetail = data;
          this.workerDetail.phone = this.workerDetail.phone.substring(0,3)+"****"+this.workerDetail.phone.substring(7,11);
          if(this.workerDetail.workTypeDesc){
            let workTypeList = this.workerDetail.workTypeDesc.replace(',', ' ');
            this.$set(this.workerDetail,'workTypeList',workTypeList);
          }
        }else {
          Toast('获取施工工人信息失败');
        }
      },
    }
  }
</script>

<style lang="scss">
  .clear-header{
    margin-top: -1rem;
  }
  .worker-detail-view{
    height: 100vh;
    background: white;
    font-size: 0.32rem;
    color: #191818;
    .header{
      display: flex;
      height: 2.7rem;
      margin: 0 auto;
      background: url("../../assets/icon-default-top-bg.png") no-repeat;
      color: white;
      .worker-avatar{
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 1.2rem;
        background: white;
        text-align: center;
        margin-top: 0.2rem;
        margin-left: 0.3rem;
        img{
          width: 1.12rem;
          height: 1.12rem;
          border-radius: 1.16rem;
          vertical-align: middle;
          margin: 0.04rem auto;
        }
      }
      .worker-name{
        margin-top: 0.6rem;
        margin-left: 0.26rem;
        font-size: 0.36rem;
        font-weight: bold;
      }
      .platform-auth{
        display: flex;
        width: 1.76rem;
        height: 0.4rem;
        line-height: 0.45rem;
        border-radius: 0.4rem;
        margin-top: 0.67rem;
        margin-left: 0.3rem;
        background: white;
        font-size: 0.24rem;
        color: #feac00;
        img{
          width: 0.27rem;
          height: 0.28rem;
          margin: 0.06rem 0.1rem 0 0.24rem;
        }
      }
    }
    .footer{
      width: 6.1rem;
      padding: 0.5rem 0.4rem 0.6rem;
      margin: -1rem auto 0;
      background: white;
      line-height: 0.65rem;
      border-radius: 0.08rem;
      box-shadow: 0rem 0.02rem 0.07rem 0rem
      rgba(0, 0, 0, 0.1);
      .cell{
        display: flex;
        .intro{
          width: 5.1rem;
          text-align: justify;
        }
      }
      .label{
        color: #7f7d7c;
      }

    }
  }
</style>
